import ContentCreate from '@mui/icons-material/Create';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { useContextMenuContext } from 'shared/mui/ContextMenu/context/contextMenuContext';
import {
  ContextMenuButton,
  ContextMenuButtonProps,
} from 'shared/mui/ContextMenu/ContextMenuButton/ContextMenuButton';

export type ContextMenuEditDialogButtonProps = Omit<Partial<ContextMenuButtonProps>, 'onClick'> & {
  onClick: NonNullable<ContextMenuButtonProps['onClick']>;
};

export const ContextMenuEditDialogButton: React.FC<ContextMenuEditDialogButtonProps> = ({
  onClick,
  label,
  icon = <ContentCreate fontSize="medium" />,
}) => {
  const translate = useTypedTranslate();
  const { onCloseMenu } = useContextMenuContext();

  const handleClick = () => {
    onClick();
    onCloseMenu();
  };

  return (
    <ContextMenuButton
      icon={icon}
      label={label || translate('app.buttons.edit')}
      onClick={handleClick}
    />
  );
};
